<template>
  <div class="mall-profile-select">
    <div class="mall-profile-select__title-area">
      <img
        class="mall-profile-select__icon"
        src="@/assets/mall/img_mall_3d.png"
        alt="컨시어지몰"
      />
      <div class="mall-profile-select__title">
        <span class="mall-profile-select__heading">어느 분이<br />구매하시나요?</span>
        <span class="typo-body-s-medium mall-profile-select__desc">환자에 따라 구매가 가능한 상품<br />혹은 가격이 달라요.</span>
      </div>
    </div>
    <div class="mall-profile-select__list">
      <MallProfileCard
        v-for="profile in profiles"
        :key="profile.id"
        :profile="profile"
        :selected="profile.id === selectedProfileId"
        @click="$emit('select', profile.id)"
      />
    </div>
  </div>
</template>

<script>
import MallProfileCard from '@/components/new/molecules/MallProfileCard.vue'

export default {
  name: 'MallProfileSelect',
  components: {
    MallProfileCard,
  },
  props: {
    profiles: {
      type: Array,
      required: true,
    },
    selectedProfileId: {
      type: Number,
      default: null,
    },
  },
}
</script>

<style scoped>
.mall-profile-select {
  display: flex;
  padding: 4px 16px 32px 16px;
  flex-direction: column;
  gap: 48px;
}

.mall-profile-select__title-area {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.mall-profile-select__icon {
  display: block;
  width: 52px;
  height: 52px;
}

.mall-profile-select__title {
  display: flex;
  padding-left: 4px;
  flex-direction: column;
  gap: 4px;
}

.mall-profile-select__heading {
  color: var(--color-text-main);
  font-family: Pretendard;
  font-size: var(--font-size-2xl);
  font-weight: var(--font-weight-semibold);
  line-height: var(--line-height-tight);
}

.mall-profile-select__desc {
  color: #8B95A1;
}

.mall-profile-select__list {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/new/organisms/MallProfileSelect.vue